import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { TPVServices } from "../../../tpv/services";
import { Globals } from "../../../../globals";
import { PrintServices } from "../../../services/printServices";
import { DatePipe } from '@angular/common';
import { ConfigurationTicketsCreatePage } from '../configuration-tickets-create/configuration-tickets-create';

/**
 * Generated class for the ConfigurationTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-ticket-print',
    templateUrl: 'configuration-ticket-print.html',
})
export class ConfigurationTicketPrintPage {

    headfooter: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public tpvServices: TPVServices,
        public globals: Globals,
        public alertCtrl: AlertController,
        public printServices: PrintServices,
        public datePipe: DatePipe) {

        //this.globals.GAtrackView('Sales', 'Sales - Ticket - Configuration - View', this.globals.restaurant.email, 'Create/Update', 'View configuration ticket', 'Sales', '');
        this.headfooter = this.navParams.get('headfooter');

    }

    edit() {
        this.navCtrl.push(ConfigurationTicketsCreatePage, {
            update_state: true,
            headfooter: this.headfooter,
        });
    }

    eTicketActive() {
        var eticket = true;
        if (this.globals.restaurant.tickets.ticket_digital || this.globals.restaurant.tickets.ticket_digital == undefined) {
            eticket = false;
        }
        this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'tickets.ticket_digital': eticket,
        }).then(() => {
            this.globals.restaurant.tickets.ticket_digital = eticket;
        });
    }

    ratingAutorSenderActive() {
        var ratingAutorSender = true;
        if (this.globals.restaurant.rating_autor_sender || this.globals.restaurant.rating_autor_sender == undefined) {
            ratingAutorSender = false;
        }
        this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'rating_autor_sender': ratingAutorSender,
        }).then(() => {
            this.globals.restaurant.rating_autor_sender = ratingAutorSender;
        });
    }

    checkTicketDigital() {
        if (this.globals.restaurant.tickets.ticket_digital || this.globals.restaurant.tickets.ticket_digital == undefined) {
            return true;
        } else {
            return false;
        }
    }

    checkRatingAutoSender() {
        if (this.globals.restaurant.rating_autor_sender || this.globals.restaurant.rating_autor_sender == undefined) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tickets/configuration-ticket-print/configuration-ticket-print.ts